import services from './services';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    mixins: [services],
    data() {
        return {
            loading: false,
            dialogVisible: false,
            title: '',
            form: this.getFormData(),
            queryType: [{
                name: '爸爸'
            }, {
                name: '妈妈'
            }, {
                name: '爷爷'
            }, {
                name: '奶奶'
            }, {
                name: '外公'
            }, {
                name: '外婆'
            }, {
                name: '其他'
            }]
        }
    },
    methods: {
        getFormData() {
            return cloneDeep({
                "DataType": '',
                "ClassId": 0,
                "BabyName": "",
                "Sex": '',
                "Birthday": "",
                // "ParentName": "",
                // "ParentNick": "",
                // "Phone": "",
            })
        },
        show(options) {
            this.form = this.getFormData()
            this.dialogVisible = true
            this.title = options.title
            this.form.ClassId = options.ClassId
            var user = sessionStorage.getItem("user");
            user = JSON.parse(user);
            this.form.DataType = user.DataType
        },
        // 确定
        submit() {
            let checkRules = [{
                name: "宝贝名字",
                value: this.form.BabyName,
                required: true,
            }, {
                name: "性别",
                value: this.form.Sex,
                required: true,
                msg: '请选择宝贝性别'
            }];
            // if (this.form.ParentName !== '' || this.form.ParentNick !== '' || this.form.PhoneNo !== '') {
            //     checkRules.push({
            //         name: "家长名字",
            //         value: this.form.ParentName,
            //         required: true,
            //     }, {
            //         name: "称呼",
            //         value: this.form.ParentNick,
            //         required: true,
            //     }, {
            //         name: "家长电话",
            //         value: this.form.Phone,
            //         phone: true,
            //     })
            // }
            var flag = util.checkForm({
                ele: this,
                rules: checkRules
            });
            if (!flag) {
                return
            }
            this.Baby_Add()
        }


    },
    computed: {

    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/LBHomeOrder/components/addBaby/vm.js